/**
 * Currency Selector Component
 */
'use client';

import { useState } from 'react';
import { ChevronDown, Globe } from 'lucide-react';
import { Button } from './Button';
import { useCurrency, SUPPORTED_CURRENCIES, Currency } from './currency-provider';

export function CurrencySelector() {
  const { currency, setCurrency } = useCurrency();
  const [isOpen, setIsOpen] = useState(false);

  const handleCurrencySelect = (newCurrency: Currency) => {
    setCurrency(newCurrency);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <Button
        variant="ghost"
        size="sm"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 h-auto"
      >
        <Globe className="h-4 w-4" />
        <span className="font-medium">
          {SUPPORTED_CURRENCIES[currency].symbol} {currency}
        </span>
        <ChevronDown className={`h-4 w-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </Button>

      {isOpen && (
        <>
          {/* Backdrop */}
          <div 
            className="fixed inset-0 z-40" 
            onClick={() => setIsOpen(false)}
          />
          
          {/* Dropdown */}
          <div className="absolute top-full right-0 mt-1 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg z-50 min-w-[200px]">
            <div className="py-1">
              {Object.entries(SUPPORTED_CURRENCIES).map(([code, data]) => (
                <button
                  key={code}
                  onClick={() => handleCurrencySelect(code as Currency)}
                  className={`w-full px-4 py-2 text-left hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center justify-between transition-colors ${
                    currency === code ? 'bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400' : ''
                  }`}
                >
                  <div className="flex flex-col">
                    <span className="font-medium">{code}</span>
                    <span className="text-xs text-gray-500 dark:text-gray-400">
                      {data.name}
                    </span>
                  </div>
                  <span className="text-sm text-gray-500 dark:text-gray-400">
                    {data.symbol}
                  </span>
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
